import classNames from "classnames";
import "./header-content";
import { ReactNode } from "react";

export interface HeaderContentProps {
  title: ReactNode;
  className?: string;
  children?: ReactNode;
  backIcon?: ReactNode;
  onBack?: () => void;
}

export function HeaderContent({
  title,
  className,
  children,
  backIcon,
  onBack,
}: HeaderContentProps) {
  return (
    <header
      className={classNames(
        "header-content bg-white p-7 flex flex-row justify-between items-center",
        className
      )}
    >
      <div className="flex gap-2 items-center">
        {!!backIcon && onBack ? (
          <button
            className="px-3 py-3 rounded-lg bg-gray-50 hover:bg-gray-100"
            onClick={() => onBack()}
          >
            {backIcon}
          </button>
        ) : null}
        {title}
      </div>
      <div>{children}</div>
    </header>
  );
}

export default HeaderContent;
